// extracted by mini-css-extract-plugin
export default {"wrapper":"EditHost_wrapper__QO4jZ","currentLink":"EditHost_currentLink__ELN2S"};